import { render, staticRenderFns } from "./StaffHeader.vue?vue&type=template&id=5e417fd8&scoped=true"
import script from "./StaffHeader.vue?vue&type=script&lang=js"
export * from "./StaffHeader.vue?vue&type=script&lang=js"
import style0 from "./StaffHeader.vue?vue&type=style&index=0&id=5e417fd8&prod&scoped=true&lang=scss"
import style1 from "./StaffHeader.vue?vue&type=style&index=1&id=5e417fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e417fd8",
  null
  
)

export default component.exports